import BootstrapIconLayersHalf from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/LayersHalf.vue'
import BootstrapIconChatText from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/ChatText.vue'
import BootstrapIconCheck2Circle from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Check2Circle.vue'
import BootstrapIconFileRichtext from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/FileRichtext.vue'
import BootstrapIconFonts from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Fonts.vue'
import BootstrapIconHeart from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Heart.vue'
import BootstrapIconMagic from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Magic.vue'
import BootstrapIconFlower3 from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Flower3.vue'
import BootstrapIconHr from '~/node_modules/nuxt-bootstrap-icons/dist/runtime/components/Hr.vue'
import IconHanger from '~/components/atoms/icons/Hanger.vue'

export const ratesIcons = [
  {
    icon: BootstrapIconMagic,
    htmlText: 'Безлимит<br>удаления фона',
  },
  {
    icon: BootstrapIconLayersHalf,
    htmlText: 'Генерация фона<br>при помощи нейросетей',
  },
  {
    icon: BootstrapIconFlower3,
    htmlText: 'Создание изображенийпри<br>при помощи нейросетей',
  },
  {
    icon: BootstrapIconHr,
    htmlText: 'Улучшение качества<br>изображений',
  },
  {
    icon: IconHanger,
    htmlText: 'Нейросеть<br>для примерки',
  },
  {
    icon: BootstrapIconFonts,
    htmlText: '219 шрифтов',
  },
  {
    icon: BootstrapIconHeart,
    htmlText: '5 000 000 иконок',
  },
  {
    icon: BootstrapIconFileRichtext,
    htmlText: '30+ Шаблонов',
  },
  {
    icon: BootstrapIconCheck2Circle,
    htmlText: 'Удобный редактор',
  },
  {
    icon: BootstrapIconChatText,
    htmlText: 'Поддержка',
  },
]
